export default __webpack_public_path__ + "3407a3f896f5ef0eb0708834977fa815.png";